import * as angular from 'angular';
import * as _ from 'underscore';
import { ViewportController } from '../../../../../app.common/modules/common/controllers/viewport-typed.controller';
import { PopupServiceCancel } from '../../../../../app.common/modules/common/models/popupServiceCancel';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { IPaginationReferralAccountFilter } from '../../../api';
import { ReferralAccountListItem, ReferralAccountPagingResult, StoreInfoListItem } from '../../../core';
import { ShopService } from '../../../places/shop.service';
import { IReferralAccountListItem } from '../../models';
import { ReferralAccountsService } from '../../referralAccounts.service';

class ReferralAccountsController extends ViewportController {
    public static $inject = ['$scope', '$q', 'referralAccountsService', 'shopService', 'popupService', 'notificationService', '$translate'];

    public waiting = false;
    public stores: StoreInfoListItem[] = [];
    public filterStores: StoreInfoListItem[] = [];
    public data: ReferralAccountPagingResult = null;
    public shoppersSelected = false;
    public allShoppersSelected = false;
    public editing = false;
    public settings = {
        filter: {
            pageSize: 10,
            page: 1,
            sortOrder: 'ascending',
            sortColumn: 'ShopperName',
            keywords: null as string,
            storeID: null as number
        },
        getPaginationFilter: (): IPaginationReferralAccountFilter => {

            const filter = this.settings.filter;
            return {
                limit: filter.pageSize,
                offset: (filter.page - 1) * filter.pageSize,
                sortColumn: filter.sortColumn,
                sortOrder: filter.sortOrder,
                keywords: filter.keywords,
                storeID: filter.storeID,
            };
        }
    };

    private asc = 'ascending';
    private desc = 'descending';
    constructor(
        private $scope: ng.IScope,
        private $q: ng.IQService,
        private referralAccountsService: ReferralAccountsService,
        private shopService: ShopService,
        private popupService: PopupService,
        private notificationService: NotificationService,
        private $translate: angular.translate.ITranslateService
    ) {
        super($scope);
        this.init();
    }

    public add = async () => {
        try {
            await this.referralAccountsService.openAccountManager(this.stores);
            this.refreshList();
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClick(error)) {
                this.notificationService.showErrorMessage();
            }
        }
    }

    public edit = (form: angular.xeditable.IEditableFormController) => {
        this.editing = true;
        form.$show();
    }

    public save = async (shopper: ReferralAccountListItem) => {
        this.cancelEdit();
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {

            await this.referralAccountsService.update({
                ShopperID: shopper.ID,
                StoreID: shopper.Store.ID
            });
            this.notificationService.showSuccessMessage();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    public remove = async (shopper: ReferralAccountListItem) => {
        try {
            await this.popupService.confirm({
                title: this.$translate.instant('remove_referral_account'),
                content: this.$translate.instant('remove_referral_account_confirm')
            });
            this.removeShoppers([shopper.ID]);
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
    }

    public removeSelected = async () => {
        try {
            await this.popupService.confirm({
                title: this.$translate.instant('remove_selected_referral_account'),
                content: this.$translate.instant('remove_selected_referral_account_confirm')
            });
            const shopperIDs = this.getSelectedShoppers().map((shopper) => {
                return shopper.ID;
            });
            this.removeShoppers(shopperIDs);
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
    }

    public onShopperSelected = () => {
        const selectedShoppers = this.getSelectedShoppers();
        this.shoppersSelected = selectedShoppers.length !== 0;
        this.allShoppersSelected = this.shoppersSelected && _.size(selectedShoppers) === _.size(this.data.Items);
    }

    public onAllShoppersSelected = () => {
        this.data.Items.forEach((shopper: IReferralAccountListItem) => {
            shopper.selected = this.allShoppersSelected;
        });
        this.onShopperSelected();
    }

    public cancelEdit = () => {
        this.editing = false;
    }

    public sort = (column: string) => {
        const filter = this.settings.filter;
        if (filter.sortColumn === column) {
            filter.sortOrder = filter.sortOrder !== this.asc ? this.asc : this.desc;
        } else {
            filter.sortColumn = column;
            filter.sortOrder = this.asc;
        }
    }

    private getSelectedShoppers = () => {
        return _.where(this.data.Items, { selected: true });
    }

    private removeShoppers = async (shopperIDs: number[]) => {
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            await this.referralAccountsService.remove(shopperIDs);
            this.refreshList();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
            this.waiting = false;
        }
    }

    private refreshList = async () => {
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            this.data = await this.referralAccountsService.list(this.settings.getPaginationFilter());
            this.shoppersSelected = false;
            this.allShoppersSelected = false;
            this.notificationService.clearAll();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    private init = async () => {
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            const result = (await this.$q.all([
                this.shopService.getStoresForFilter(),
                this.refreshList() as angular.IPromise<void>
            ]));
            this.stores = result[0];
            this.filterStores = this.stores.slice();
            this.filterStores.unshift({
                ID: null,
                Name: 'All'
            });
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
        this.$scope.$watch('vm.settings.filter', (n: any, o: any) => {
            if (n !== o) {
                this.refreshList();
            }
        }, true);

    }
}

angular
    .module('naut')
    .component('referralAccounts', {
        template: require('./referralAccounts.html'),
        controller: ReferralAccountsController,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/referral-accounts/components/referralAccounts/referralAccounts.component.ts